import { atom } from "recoil";

export const createUserDrawerState = atom({
  key: "createUserDrawerState", // unique ID (with respect to other atoms/selectors)
  default: null, // default value (aka initial value)
});
